import { render, staticRenderFns } from "./new-request.vue?vue&type=template&id=a74bb71e"
import script from "./new-request.js?vue&type=script&lang=js&external"
export * from "./new-request.js?vue&type=script&lang=js&external"
import style0 from "./new-request.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports